// components/MapZoomHandler.tsx
import { useMap } from 'react-leaflet';
import { useEffect } from 'react';

interface Props {
  center: { latitude: number; longitude: number };
}

const MapZoomHandler: React.FC<Props> = ({ center }) => {
  const map = useMap();

  useEffect(() => {
    if (center) {
      map.flyTo([center.latitude, center.longitude], 13);
    }
  }, [center, map]);

  return null;
};

export default MapZoomHandler;
